import { getAssetPath } from "@stencil/core";

export type IconSetResolver = (name: string) => string;

export type IconSetMutator = (svg: SVGElement) => void;

export interface IconSet {
    name: string;
    resolver: IconSetResolver;
    mutator?: IconSetMutator;
}

export interface IconSetIcon {
    iconSet: string;
    iconName: string;
}

export class IconSetRegistry {
    private _sets = new Map<string, IconSet>();

    constructor() {
        this.addSet("uic", (name) => {
            const path = getAssetPath(`./icons/icons.svg`);
            return `${path}#${name}`;
        });
    }

    addSet(name: string, resolver: IconSetResolver, mutator?: IconSetMutator) {
        const iconset = { name, resolver, mutator };
        this._sets.set(name, iconset);
    }

    getSet(name: string): IconSet {
        return this._sets.get(name);
    }

    removeSet(name: string): void {
        this._sets.delete(name);
    }

    resolveIconSrc(icon: IconSetIcon): string {
        const set = this.getSet(icon.iconSet);
        if (set) {
            return set.resolver(icon.iconName);
        }

        return `#${icon.iconName}`;
    }
}

export function parseIconFromName(name: string): IconSetIcon {
    const parts = name.split(":");
    let iconSet = "default";
    let iconName = name;

    if (parts.length > 1) {
        iconSet = parts[0];
        iconName = parts[1];
    }

    return {
        iconSet,
        iconName,
    };
}

export const RegistryInstance = new IconSetRegistry();
